import segment from 'src/js/modules/analytics/segment';

const {
  constants: { events },
  trackers: { trackEvent },
} = segment;

export function trackSearchClicked() {
  trackEvent(events.BLOCK_LIBRARY_SEARCH_CLICKED);
}

export function trackOnlineStoreSeen() {
  trackEvent(events.BLOCK_LIBRARY_ONLINE_STORE_SEEN);
}

export function trackCustomBlockSeen() {
  trackEvent(events.BLOCK_LIBRARY_CUSTOM_BLOCK_SEEN);
}

export function trackSearchPerformed({ searchTerm, searchResults }) {
  trackEvent(events.BLOCK_LIBRARY_SEARCH_PERFORMED, {
    searchTerm,
    searchResults,
  });
}

export function trackCategorySelected(categoryId) {
  trackEvent(events.BLOCK_LIBRARY_CATEGORY_SELECTED, {
    categoryId,
  });
}

export function trackBlocksStyleChanged({ categoryId, styleId }) {
  trackEvent(events.BLOCK_LIBRARY_BLOCKS_STYLE_CHANGED, {
    categoryId,
    styleId,
  });
}

export function trackTutorialClicked(tutorialName) {
  trackEvent(events.BLOCK_LIBRARY_TUTORIAL_CLICKED, {
    tutorialName,
  });
}

export function trackFilterSelected({ categoryId, selectedFilter }) {
  trackEvent(events.BLOCK_LIBRARY_FILTER_SELECTED, {
    categoryId,
    selectedFilter,
  });
}
